// extracted by mini-css-extract-plugin
module.exports = {"shopByWrapper":"_ae5b9891","itemsWrapper":"_3f31a168"};